import request from '@/utils/request'

/**
 * 获取已发布的快捷入口
 *
 * @export
 * @returns
 */
export function getFastEntry() {
  return request({
    url: 'content/fast_entry/list/displayed',
    method: 'get'
  })
}

/**
 * 获取所有顶部配置
 *
 * @export
 * @returns
 */
export function getAllTopSign() {
  return request({
    url: 'content/topSign/all',
    method: 'get'
  })
}

/**
 * 获取所有广告配置
 *
 * @export
 * @returns
 */
export function getAllPop() {
  return request({
    url: 'content/pop_config/all',
    method: 'get'
  })
}

/**
 * 获取主题列表
 *
 * @export
 * @returns
 */
export function getThemeConfig() {
  return request({
    url: 'content/theme_config/all',
    method: 'get'
  })
}

/**
 * 获取友情链接
 *
 * @export
 * @returns
 */
export function getRelationshipList() {
  return request({
    url: 'content/relationship_url/all',
    method: 'get'
  })
}

/**
 * 获取边栏列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getSideMenu(params) {
  return request({
    url: 'content/sider_config/all',
    method: 'get',
    params
  })
}

/**
 * 获取广告配置
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getAdvertConfig(params) {
  return request({
    url: 'content/gg_config/all',
    method: 'get',
    params
  })
}

/**
 * 获取底部配置
 *
 * @export
 * @returns
 */
export function getWebSiteInfo() {
  return request({
    url: 'content/websiteInfo',
    method: 'get'
  })
}

/**
 * 获取搜索热词
 *
 * @export
 * @returns
 */
export function getSearchHotWord(params) {
  return request({
    url: 'content/search_record/hot',
    method: 'get',
    params
  })
}

/**
 * 获取公共服务（遵规守纪清单/下载中心/更多）
 *
 * @export
 * @returns
 */
export function getServiceColumns() {
  return request({
    url: 'content/column/columnsForList',
    method: 'get'
  })
}

/**
 * 通知快讯
 *
 * @export
 * @returns
 */
export function getNotice() {
  return request({
    url: 'content/column/notice_express',
    method: 'get'
  })
}

/**
 * 搜索内容
 *
 * @export
 * @param {*} params
 * @returns
 */
export function search(params) {
  return request({
    url: 'content/elasticSearch/page',
    method: 'get',
    params
  })
}

/**
 * 获取首页栏目
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getHomeColumns(params) {
  return request({
    url: 'content/column/table',
    method: 'get',
    params
  })
}

/**
 * 分页获取问卷调查列表信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getQuestionnairePublished(params) {
  return request({
    url: 'content/questionnaire/list/published',
    method: 'get',
    params
  })
}

/**
 * 根据questionnaireId获得问卷题目和选项
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getQuestionnaireDetail(params) {
  return request({
    url: 'content/questionnaire/show',
    method: 'get',
    params
  })
}

/**
 * 提交问卷-发送手机短信
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getSendSMS(params) {
  return request({
    url: 'content/questionnaire/free/send/SMS',
    method: 'get',
    params
  })
}

/**
 * 未备案举报-发送手机短信
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getReportSendSMS(params) {
  return request({
    url: 'credit/report_norecord/free/send/SMS',
    method: 'get',
    params
  })
}

/**
 * 用户提交问卷调查
 *
 * @export
 * @param {*} data
 * @returns
 */
export function addAnswers(data) {
  return request({
    url: 'content/questionnaire/add/anwsers',
    method: 'post',
    data
  })
}

/**
 * 根据问卷记录id获取问卷答卷
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getAnswerDetail(params) {
  return request({
    url: 'content/questionnaire/answer_record/details',
    method: 'get',
    params
  })
}

export function getServiceList(params) {
  return request({
    url: 'content/service_management/list/displayed',
    method: 'get',
    params
  })
}

export function getMenu(params) {
  return request({
    url: 'content/column/columnsByParentId',
    method: 'get',
    params
  })
}

export function getAriticleList(params) {
  return request({
    url: 'content/article/getByColumnId',
    method: 'get',
    params
  })
}

/**
 * id查询文章带模板
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getAriticle(params) {
  return request({
    url: 'content/article/id',
    method: 'get',
    params
  })
}

/**
 * 增加文章点赞数量
 *
 * @export
 * @param {*} params
 * @returns
 */
export function likeAriticle(params) {
  return request({
    url: 'content/article/addLikeCount',
    method: 'get',
    params
  })
}

/**
 * 增加文章分享记录
 *
 * @export
 * @param {*} params
 * @returns
 */
export function shareAriticle(params) {
  return request({
    url: 'content/article/addShareLog',
    method: 'get',
    params
  })
}

export function getAriticleShareStatus(params) {
  return request({
    url: 'content/article/canAddGood',
    method: 'get',
    params
  })
}

/**
 * 增加文章阅读数量
 *
 * @export
 * @param {*} params
 * @returns
 */
export function readAriticle(params) {
  return request({
    url: 'content/article/addReadCount',
    method: 'get',
    params
  })
}

/**
 * 官网-备案进度查询
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getRecordProgress(params) {
  return request({
    url: 'user/todo/organRecord/free/official/get/progress/rate/',
    method: 'get',
    params
  })
}

/**
 * 官网-获取公示的备案状态机构信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getRecordList(params) {
  return request({
    url: 'user/organ/free/official/get/recordStatus/list',
    method: 'get',
    params
  })
}

/**
 * 官网-获取公示的备案机构信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getOrgRecordList(params) {
  return request({
    url: 'user/organ/free/official/get/isRecord/list',
    method: 'get',
    params
  })
}

/**
 * 官网-获取公示的备案分支机构信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getBranchRecordList(params) {
  return request({
    url: 'user/branch/free/official/get/isRecord/list',
    method: 'get',
    params
  })
}

/**
 * 官网-获取公开年报信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getOfficialOpenList(params) {
  return request({
    url: 'user/nb/organ/basic/info/free/official/open/list',
    method: 'get',
    params
  })
}

/**
 * 新增访问数据
 *
 * @export
 * @param {*} data
 * @returns
 */
export function addBrowseLog(params) {
  return request({
    url: 'content/browseLog',
    method: 'post',
    params,
    data: {}
  })
}

/**
 * 根据手机号码查询列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getReportListByMobile(params) {
  return request({
    url: 'credit/report_norecord/free/get/list/by/mobile',
    method: 'get',
    params
  })
}

/**
 * 根据手机号码查询列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getReportDetail(id) {
  return request({
    url: `credit/report_norecord/free/${id}`,
    method: 'get'
  })
}

/**
 * 根据手机号码查询列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function addReport(data) {
  return request({
    url: 'credit/report_norecord/free/add/info',
    method: 'post',
    data
  })
}

/**
 * 官网查询用户投诉列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getComplaintByMobile(params) {
  return request({
    url: 'credit/complaint/application/free/official/all',
    method: 'get',
    params
  })
}

/**
 * 根据id查询申请
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getComplaintDetail(params) {
  return request({
    url: 'credit/complaint/application/free/get/info',
    method: 'get',
    params
  })
}

/**
 * 投诉申请-发送手机短信
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getComplaintSMS(params) {
  return request({
    url: 'credit/complaint/application/free/send/SMS',
    method: 'get',
    params
  })
}

/**
 * 撤销用户申请
 *
 * @export
 * @param {*} params
 * @returns
 */
export function revokeMyComplaint(data) {
  return request({
    url: 'credit/complaint/application/free/revoke',
    method: 'put',
    data
  })
}

/**
 * 回复申请进度消息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function replyMyComplaint(data) {
  return request({
    url: 'credit/complaint/application/free/reply',
    method: 'put',
    data
  })
}

/**
 * 获取siss系统基本配置
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getOptionName(params) {
  return request({
    url: 'basic/sysconfig/get/value/by/optionName',
    method: 'get',
    params
  })
}

export function getDictName(params) {
  return request({
    url: 'basic/sissdictitem/get/redisData/byTypeId',
    method: 'get',
    params
  })
}

export function searchBrokerByNameOrLicenseNo(params) {
  return request({
    url: 'user/person/get/person/info/list/by/name/or/licenseNo',
    method: 'get',
    params
  })
}

export function insertSissComplainRecord(data) {
  return request({
    url: 'credit/complaint/application/free/add',
    method: 'post',
    data
  })
}

export function updateSissComplainRecord(data) {
  return request({
    url: 'credit/complaint/application/free/update',
    method: 'put',
    data
  })
}

export function getSissComplaintType(params) {
  return request({
    url: 'credit/complaint/type/free/get/notification/info',
    method: 'get',
    params
  })
}

export function getSissComplaintTypeTree(params) {
  return request({
    url: 'credit/complaint/type/free/get/notification/tree',
    method: 'get',
    params
  })
}

export function checkComplaintPersonRepeat(data) {
  return request({
    url: 'credit/complaint/application/free/repeat/application/judge/',
    method: 'post',
    data
  })
}

/**
 * 机构经纪会员
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getBrokerMember(params) {
  return request({
    url: 'user/star/access/organ/youhua',
    method: 'get',
    params
  })
}

/**
 * 累加点击数量
 *
 * @export
 * @param {*} data
 * @return {*}
 */
export function addColumnsReadCount(data) {
  return request({
    url: 'content/column/columnsReadCount',
    method: 'put',
    data
  })
}

/**
 * 获取纪念人列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getRememberList(params) {
  return request({
    url: 'content/message/page',
    method: 'get',
    params
  })
}

/**
 * 获取纪念人数量
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getRememberCount(params) {
  return request({
    url: 'content/message/count',
    method: 'get',
    params
  })
}

/**
 * 纪念
 *
 * @export
 * @param {*} data
 * @return {*}
 */
export function addRemember(data) {
  return request({
    url: 'content/message',
    method: 'post',
    data
  })
}

/**
 * 纪念
 *
 * @export
 * @param {*} data
 * @return {*}
 */
export function addAnniversary(data) {
  return request({
    url: 'content/anniversary/add/count',
    method: 'post',
    data
  })
}

export function getRandomCode() {
  return request({
    url: 'message/message/random/verification/code',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js